import { combineReducers } from 'redux';

import { SEARCH, SORT } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';
import loadingArray from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

import details from './details';
import * as types from '../../actionTypes';
import { GATE_DASHBOARD } from '../../constants';

const persistedFilters = getPersistedFilters()?.filters?.gates ?? {};

const emptyState = {
  [SEARCH]: null,
  [SORT]: 'name,ASC',
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

/**
 * @typedef {{
 *   dashboard: {
 *     data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *     loading: {
 *       delete: import("modules/global/reducers/loadingArraySlice").LoadingArraySlice,
 *     },
 *     sort: string,
 *     filters: Object,
 *   },
 *   details : {
 *     loading: {
 *       creating: boolean,
 *       updating: boolean,
 *       relayCheck: boolean,
 *     },
 *     ready: boolean,
 *   },
 *   selects: import("modules/global/reducers/generic.selectSlice").GenericSelectsReducer,
 * }} GateUIReducer
 */

export const dashboardMatcher = ({ meta }) => meta?.target === GATE_DASHBOARD;

export const data = createSearchReducers(types.FETCH_GATES, {
  global: { matcher: dashboardMatcher, paginationSlice: true },
});

export const selectId = entity => entity?.gateId ?? entity?.id ?? entity;

export const loadingReducer = combineReducers({
  delete: loadingArray(types.DELETE_GATE, { global: { selectId } }),
});

const availableGatesReducer = genericSelectSlice(types.FETCH_AVAILABLE_GATES);

const filterGatesReducer = genericSelectSlice(types.FETCH_GATES_FILTER, {
  global: { selectId: entity => entity },
});

export const selectsReducer = (state, action) => filterGatesReducer(availableGatesReducer(state, action), action);

export const filters = createReducer(filterAdapter.getInitialState(), {
  [types.SET_GATES_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.CLEAR_GATES_DASHBOARD_FILTER]: filterAdapter.resetFilters,
});

export default combineReducers({
  dashboard: combineReducers({
    data,
    loading: loadingReducer,
    filters,
  }),
  details,
  selects: selectsReducer,
});
